export default {
    apiKey: "AIzaSyBVfHE0zRA7xDv1nFYTXqNrSXGB88oV11E",
    authDomain: "balletschool927.firebaseapp.com",
    databaseURL: "https://balletschool927.firebaseio.com",    
    projectId: "balletschool927",
    storageBucket: "balletschool927.appspot.com",
    messagingSenderId: "494877903530",
    appId: "1:494877903530:web:6f6946ceee4351c8c5ded3",
    measurementId: "G-9LSJMWMS9F"
  };


// WEBPACK FOOTER //
// ./src/firebase/firebase.js